// extracted by mini-css-extract-plugin
export default {"badge":"PlatformBadge_badge__PihOC","icon":"PlatformBadge_icon__BIZ5N","label":"PlatformBadge_label__iRZf5"};